import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Utility } from '../../shared/utility/utility';
@Component({
  selector: 'app-country-blocked',
  templateUrl: './country-blocked.component.html',
  styleUrls: ['./country-blocked.component.scss']
})
export class CountryBlockedComponent {
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  countryBlockBg: string = this.siteUrlPath + "/" + this.mediaUrlPath + "/countryblock-bg.png";


  constructor(
    private utility: Utility
  ) { }

  closeModal(modalId){
    this.utility.closeModal(modalId);
  }
}
